import { injectable, inject } from 'inversify';
import JsonRpcDispatcher, { interceptors } from '@dealroadshow/json-rpc-dispatcher';
import Container from '@framework/di/Container';
import AdapterFactory from '@framework/di/Providers/Rpc/AdapterFactory';
import addSessionData from '@users/session/interceptors/rpc/addSessionData';
import checkSession from '@users/session/interceptors/rpc/checkSession';
import parseWrappedError from '@framework/api/Rpc/parseWrappedError';
import url from '@/creditflowresearch/infrastructure/url';
import DITypes from './DI/types';

@injectable()
export class RpcDispatcherFactory {
  constructor(
    @inject(Container) private readonly container: Container,
    @inject(DITypes.AdapterFactory) private readonly adapterFactory: AdapterFactory,
  ) {}

  create(): JsonRpcDispatcher {
    const adapter = this.adapterFactory.create(
      url.getAskAiRpcUrl(),
      { otelPropagation: true },
    );

    const dispatcher = new JsonRpcDispatcher(adapter);

    dispatcher
      .interceptRequest(addSessionData(this.container))
      .interceptResponse(checkSession(this.container))
      .interceptResponse(parseWrappedError())
      .interceptResponse(interceptors.response.transformErrorToException);

    return dispatcher;
  }
}
